import axiosConfig from "./axiosConfig";

export interface OutreachDraftRequest {
  role: "tenant" | "landlord";
  contactEmail: string;
  contactName?: string | null;
  calendlyUrl?: string;
}

export interface OutreachDraftResponse {
  // Present on success:
  role?: "tenant" | "landlord";
  draftText?: string;
  facts?: Record<string, unknown>;
  calendlyUrl?: string;
  // The draft lands in the logged-in user's Gmail; null + gmailError when
  // delegation isn't configured (the text is still returned to copy).
  gmailDraftId?: string | null;
  gmailError?: string | null;
  // Present when the draft was refused (suppressed contact / too little data):
  blocked?: boolean;
  reason?: string;
}

const postLeadOutreachDraft = async (
  authToken: string,
  leadId: string,
  body: OutreachDraftRequest
): Promise<OutreachDraftResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${leadId}/outreach/draft`,
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadOutreachDraft;
